export default __webpack_public_path__ + "static/media/spring-boot.606fc352.svg";